import { lazy } from "react";

export const importView = (name) => {
  return lazy(() => import(/* webpackChunkName: "cust-[request]" */ `modules/error/views/${name}`));
};
